
const API = {
  base: 'https://t4vi6nkws2.execute-api.us-west-2.amazonaws.com/BarrHouse',
  routes: {
    newReservation: '/newReservation/'
  },
};

export default API;



/** WEBPACK FOOTER **
 ** ./src/constants/api.js
 **/